import { useEffect, useState } from 'react';
import { getGeoUrl } from '../config';

let cache = { status: 'idle', payload: null };
let inflight = null;

async function loadGeo() {
  try {
    const r = await fetch(getGeoUrl(), { method: 'GET' });
    const text = await r.text();
    let data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch {
      data = {};
    }
    if (r.ok && data && !data.error) {
      return data;
    }
  } catch {
    /* checkout works without geo */
  }
  return null;
}

function ensureGeo() {
  if (cache.status === 'done') {
    return Promise.resolve(cache.payload);
  }
  if (!inflight) {
    cache.status = 'loading';
    inflight = loadGeo().then((payload) => {
      cache = { status: 'done', payload };
      return payload;
    });
  }
  return inflight;
}

export function peekCheckoutGeo() {
  return cache.payload;
}

export function useCheckoutGeo() {
  const [state, setState] = useState(() => ({
    loading: cache.status !== 'done',
    payload: cache.payload,
  }));

  useEffect(() => {
    let cancelled = false;
    ensureGeo().then((payload) => {
      if (!cancelled) {
        setState({ loading: false, payload });
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
